import { styled } from '@mui/system';
import Button from '@mui/material/Button/index';
import { Paper, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export const NotificationsCnt = styled('div')(() => ({
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto'
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing()
}));

export const StyledSubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  },
  display: 'flex',
  flexDirection: 'column'
}));

export const ButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const StyledBtn = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));

export const ChannelsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  columnGap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}));

export const ChannelLabel = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4
}));

export const InfoBadge = styled('span')(() => ({
  display: 'inline-flex',
  pointerEvents: 'auto',
  lineHeight: 0,
  position: 'relative',
  top: -4
}));

export const StyledInfoIcon = styled(InfoIcon)(() => ({
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.54)'
}));
